<template>
    <div class="filter-group">
        <div class="filter-toolbars-container">
            <div class="filter-toolbars">
                <div class="filter-toolbar" v-for="(facetGroup, index) in facetGroups" :key="`facet-group-${index}`">
                    <div v-if="showGroup && facetGroup[0].group" class="filter-component facet-group-title">
                        <div class="display-text">{{ facetGroup[0].group }}</div>
                    </div>
                    <FilterGroupFacet
                        v-for="facet in facetGroup"
                        :key="facet.path"
                        :criteria.sync="boundCriteria"
                        :facet="facet"
                    />
                </div>
            </div>
            <slot />
        </div>
        <div class="filter-chips">
            <div v-for="(criterion, index) in visibleCriteria" :key="`criterion-${index}`" @click="remove(index)">
                {{ criterion.display ?? criterion.value }}
                &times;
            </div>
            <a href="#" v-if="visibleCriteria.length > 0" @click.prevent="clear">Clear All</a>
        </div>
    </div>
</template>
<script>
import { toDictionary } from '@/utils/array'

import FilterGroupFacet from './filter-group/facet.vue'

export default {
    model: {
        prop: 'criteria',
        event: 'update:criteria',
    },
    components: {
        FilterGroupFacet,
    },
    props: {
        facets: {
            type: Array,
            default() {
                return []
            },
        },
        criteria: {
            type: Array,
            default() {
                return []
            },
        },
    },
    computed: {
        boundCriteria: {
            get() {
                return this.criteria
            },
            set(value) {
                this.$emit('update:criteria', value)
            },
        },
        facetGroups() {
            const groups = []
            const lookup = {}

            this.facets.forEach(f => {
                const key = f.group
                let group = lookup[key]

                if (group === undefined) {
                    groups.push((lookup[key] = group = []))
                }

                group.push(f)
            })

            return groups
        },
        showGroup() {
            return this.facetGroups.length > 1
        },
        visibleCriteria() {
            var facetsDictionary = toDictionary(this.facets, f => f.name)
            var visibleCriteria = []
            this.criteria.forEach(c => {
                var criterion = facetsDictionary[c.name]
                if (criterion) {
                    visibleCriteria.push({ ...c, type: criterion.type, title: criterion.title })
                }
            })

            return visibleCriteria
        },
    },
    methods: {
        clear() {
            this.$emit('update:criteria', [])
        },
        remove(index) {
            const criteria = this.criteria.slice()

            if (index > -1) {
                criteria.splice(index, 1)
                this.boundCriteria = criteria
            }
        },
    },
}
</script>
<style>
.filter-group {
    margin-bottom: 24px;
    clear: both;

    .facet-group-title {
        margin-right: 16px;

        .display-text {
            line-height: 24px;
            border-right: 1px solid var(--color-primary-200);
            padding-right: 16px;
            min-width: 96px;
        }
    }

    .filter-toolbars-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .filter-toolbars {
        flex: 1 0 1%;
        margin-bottom: 24px;
        width: 100%;
    }

    .filter-toolbar {
        border-top: 0.5px solid var(--color-primary-200);
        padding: 0px var(--spacing-1) var(--spacing-0) 0px;

        &:last-child {
            border-bottom: 0.5px solid var(--color-primary-200);
        }
    }

    .filter-chips {
        & > * {
            color: #333333;
            cursor: pointer;
            display: inline-block;
            font-family: Lato;
            font-size: 11px;
            line-height: 25px;
            letter-spacing: 0.32px;
            margin-right: var(--spacing-2);
            margin-bottom: var(--spacing-1);
            padding: 0 var(--spacing-1);
        }

        & > div {
            border: 1px solid #d0cfd3;
            border-radius: 2px;
            background-color: #fcfcfc;
        }

        & > a {
            text-transform: uppercase;
            text-decoration: underline;
        }
    }

    .filter-group-options {
        float: right;
    }
}
</style>
